import { useState, useEffect, useRef, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faXmark } from '@fortawesome/free-solid-svg-icons';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
  className?: string;
}

function SearchInputComponent({
  value,
  onChange,
  placeholder = 'ค้นหา...',
  debounceMs = 800,
  className = '',
}: SearchInputProps) {
  const [input, setInput] = useState(value);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (value === '') setInput('');
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => onChangeRef.current(input), debounceMs);
    return () => clearTimeout(timer);
  }, [input, debounceMs]);

  return (
    <div className={`flex items-center gap-2 border border-gray-300 dark:border-slate-600 rounded-lg px-3 py-2 bg-white dark:bg-slate-700 focus-within:ring-2 focus-within:ring-primary/20 dark:focus-within:ring-slate-600 min-w-[220px] ${className}`}>
      <FontAwesomeIcon icon={faSearch} className="text-gray-400 dark:text-slate-500 text-sm shrink-0" />
      <input
        type="text"
        placeholder={placeholder}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        className="text-sm focus:outline-none flex-1 bg-transparent text-gray-700 dark:text-slate-200 placeholder-gray-400 dark:placeholder-slate-500 min-w-0"
      />
      {input && (
        <button
          type="button"
          onClick={() => { setInput(''); onChangeRef.current(''); }}
          className="text-gray-400 dark:text-slate-500 hover:text-red-500 dark:hover:text-red-400 transition-colors shrink-0"
        >
          <FontAwesomeIcon icon={faXmark} className="text-xs" />
        </button>
      )}
    </div>
  );
}

const SearchInput = memo(SearchInputComponent);
export default SearchInput;
